'use strict';

exports.__esModule = true;

var _symbolObservable = require('symbol-observable');

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var defineObservableSymbol, returnThis;

returnThis = function () {
  return this;
};

exports.default = defineObservableSymbol = function (obj, observableGetter) {
  if (typeof observableGetter !== 'function') {
    observableGetter = returnThis;
  }
  return Object.defineProperty(obj, _symbolObservable2.default, {
    value: observableGetter,
    writable: true,
    configurable: true,
    enumerable: true
  });
};